<template>
  <div>
    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description class="pt-1" :field="field" />
      <el-row type="flex" :gutter="15">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <div class="flex items-center gap-3 w-full">
        <div class="flex flex-col gap-2 w-1/2">
          <label for="" class="text-lightGray text-xs 2xl:!text-sm font-normal">
            Add Separator
          </label>
          <el-input
            class="w-full"
            maxlength="50"
            min="3"
            resize="none"
            v-model="field.separator"
            placeholder="add any separator"
          ></el-input>
        </div>
        <span class="w-1/2">
          <div class="!flex flex-col items-start gap-2 w-full">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block"
            >
              Select Field
            </label>
            <span class="w-full flex items-center justify-center !gap-2">
              <el-select
                placeholder="Select Field"
                v-model="selectedFieldKey"
                filterable
                clearable
                @change="updateSelectedField"
              >
                <el-option
                  v-for="(f, index) in allFields"
                  :key="index"
                  :label="f.label"
                  :value="f.key"
                  :disabled="disableOption(f)"
                ></el-option>
              </el-select>
              <el-button
                class="!p-0"
                style="background: var(--brand-500) !important"
                @click="addOptionToList"
              >
                <div
                  class="w-fit !flex w-24 items-center justify-center gap-2 !text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:!text-sm"
                >
                  <img src="../../../assets/img/icons/new/whiteplus-icon.svg" alt="" />
                  <span>Add</span>
                </div>
              </el-button>
            </span>
          </div>
        </span>
      </div>
      <div class="flex items-center justify-between gap-3 pt-1">
        <div class="flex flex-col gap-1.5 w-1/2">
          <el-checkbox
            label="Remove special characters"
            v-model="field.remove_special_characters"
          ></el-checkbox>
          <el-checkbox label="show labels" v-model="field.show_labels"></el-checkbox>
        </div>
        <div class="w-1/2">
          <is-field-required :field="field" class="field-required" />
        </div>
      </div>
      <el-row>
        <div class="icon-dropdown-selection flex items-center !gap-3">
          <span
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            Icon
          </span>
          <el-button type="text" @click="iconPickerdialogVisible = true">
            <div class="d-flex align-center menu-icon !gap-2">
              <span>
                <icons :iconName="templateIconPath"></icons>
              </span>
              <i class="el-icon-circle-plus !text-brand-500"></i>
            </div>
          </el-button>
        </div>
      </el-row>
      <el-row type="flex" :gutter="30">
        <el-col :span="20" class="pb-3">
          <u>Drag Fields to Change order</u>
          <el-button
            type="danger"
            @click="popField()"
            class="btn-operation"
            size="mini"
            :disabled="field.selected_fields.length < 1"
            style="margin-left: 8px"
          >
            <i class="el-icon-delete w-4"></i>
          </el-button>
          <draggable v-model="field.selected_fields">
            <div class="!w-full" style="overflow-x: auto">
              <th class="!pr-2 !py-2" v-for="(column, index) in field.selected_fields" :key="index">
                <el-tag effect="dark">
                  {{ column.label }}
                </el-tag>
              </th>
            </div>
          </draggable>
        </el-col>
      </el-row>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  export default {
    name: 'Concatenate',
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      Placeholder: () => import('./Placeholder'),
      draggable,
    },

    props: ['field', 'fieldsData'],
    computed: {
      allGlobalVariables() {
        return this.getAllGlobalVariables ? this.getAllGlobalVariables.data || [] : [];
      },
    },
    mounted() {
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
      let exceptionFields = [
        'HTML',
        'HEADING',
        'STAR_RATING',
        'HORIZONTAL_LINE',
        'DATA_TABLE',
        'IMAGE',
        'VIDEO',
        'DIVISION',
        'ACTION_BUTTON',
        'SIGNATURE',
      ];

      if (this.field.data_table_field_index > -1) {
        this.allFields = this.fieldsData[
          this.field.data_table_field_index
        ].data_table_columns.filter(
          (e) => e && !exceptionFields.includes(e.input_type) && e.key !== this.field.key
        );
      } else {
        this.allFields = this.fieldsData.filter(
          (e) => e && !exceptionFields.includes(e.input_type) && e.key != this.field.key
        );
      }
    },
    data() {
      return {
        allFields: [],
        selectedFieldKey: '',
        selectedField: {},
        separator: '',
        iconPickerdialogVisible: false,
        getAllGlobalVariables: null,
        templateIconPath: 'dashboard',
      };
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
      addOptionToList() {
        if (this.selectedFieldKey) {
          this.field.selected_fields.push(this.selectedField);
          this.selectedFieldKey = '';
          this.selectedField = {};
        } else {
          this.$message.error('Please select Field!');
        }
      },
      updateSelectedField() {
        if (this.field.data_table_field_index > -1) {
          this.selectedField = this.fieldsData[
            this.field.data_table_field_index
          ].data_table_columns.find((e) => e.key == this.selectedFieldKey);
        } else {
          this.selectedField = this.fieldsData.find((e) => e.key == this.selectedFieldKey);
        }
      },
      disableOption(field) {
        let allSelectedFieldKeys = this.field.selected_fields.map((e) => e.key);
        if (allSelectedFieldKeys.includes(field.key)) {
          return true;
        }
        return false;
      },
      popField() {
        this.field.selected_fields.pop();
      },
    },
  };
</script>

<style lang="scss"></style>
